import { useTranslation } from 'react-i18next';
import { LanguageType } from '@/common/types/general';
import { INTL_MONTH_DAY_FORMAT, intlFormat } from '@/common/utils/date';
import { InsuranceUpgradeEducationalPoint } from '@/web/containers/Insurance/InsuranceUpgrade/InsuranceUpgradePlanPage/components/InsurancePlanChooseStep/components/InsuranceUpgradeLearningCentre/components/InsuranceUpgradeEducationalPoint/InsuranceUpgradeEducationalPoint';
import { DocUpgradeIllustration } from '@/web/containers/Insurance/InsuranceUpgrade/InsuranceUpgradePlanPage/components/InsurancePlanChooseStep/components/InsuranceUpgradeLearningCentre/components/illustrations/DocUpgradeIllustration/DocUpgradeIllustration';
import { FamilyHearthIllustration } from '@/web/containers/Insurance/InsuranceUpgrade/InsuranceUpgradePlanPage/components/InsurancePlanChooseStep/components/InsuranceUpgradeLearningCentre/components/illustrations/FamilyHearthIllustration/FamilyHearthIllustration';
import { PlusShieldIllustration } from '@/web/containers/Insurance/InsuranceUpgrade/InsuranceUpgradePlanPage/components/InsurancePlanChooseStep/components/InsuranceUpgradeLearningCentre/components/illustrations/PlusShieldIllustration/PlusShieldIllustration';
import cx from 'classnames';
import css from './InsuranceUpgradeLearningCentre.module.css';

export const InsuranceUpgradeLearningCentre = ({
  className,
  startDate = '',
  limitDate = '',
  hideFamilyEducationalPoint,
}: TInsuranceUpgradeLearningCentreProps) => {
  const { t, i18n } = useTranslation();

  return (
    <div className={cx(css.root, className)}>
      <InsuranceUpgradeEducationalPoint
        illustration={<PlusShieldIllustration />}
        title={t(
          'dashboard.insurance.upgrade_plan.learning_centre.educational_point.company_offer.title'
        )}
        description={t(
          'dashboard.insurance.upgrade_plan.learning_centre.educational_point.company_offer.description',
          {
            date: intlFormat(startDate, INTL_MONTH_DAY_FORMAT, {
              language: i18n.language as LanguageType,
            }),
          }
        )}
      />
      <InsuranceUpgradeEducationalPoint
        illustration={<DocUpgradeIllustration />}
        title={t(
          'dashboard.insurance.upgrade_plan.learning_centre.educational_point.upgrade_conditions.title',
          {
            date: intlFormat(limitDate, INTL_MONTH_DAY_FORMAT, {
              language: i18n.language as LanguageType,
            }),
          }
        )}
        description={t(
          'dashboard.insurance.upgrade_plan.learning_centre.educational_point.upgrade_conditions.description'
        )}
      />
      {!hideFamilyEducationalPoint && (
        <InsuranceUpgradeEducationalPoint
          illustration={<FamilyHearthIllustration />}
          title={t(
            'dashboard.insurance.upgrade_plan.learning_centre.educational_point.family_protection.title'
          )}
          description={t(
            'dashboard.insurance.upgrade_plan.learning_centre.educational_point.family_protection.description'
          )}
        />
      )}
    </div>
  );
};

export type TInsuranceUpgradeLearningCentreProps = {
  className?: string;
  startDate?: string;
  limitDate?: string;
  hideFamilyEducationalPoint?: boolean;
};
